/* RZ — JS propio de la tienda. Todo vanilla, sin librerías externas. */
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initResenasMarquesina();
  initGaleriaProducto();
  initProducto();
  initCantidadProducto();
  initComparadorAntesDespues();
  initContador();
});

/* ---------- Contador de oferta (cuenta atrás) ---------- */
function initContador() {
  document.querySelectorAll('[data-rz-contador]').forEach(function (el) {
    var modo = el.getAttribute('data-modo');
    var alTerminar = el.getAttribute('data-al-terminar') || 'reiniciar';
    var horas = parseFloat(el.getAttribute('data-horas')) || 12;
    var reloj = el.querySelector('[data-rz-contador-reloj]');
    var finMsg = el.querySelector('[data-rz-contador-fin]');
    var grupoDias = el.querySelector('[data-rz-dias]');
    var elD = el.querySelector('[data-rz-d]');
    var elH = el.querySelector('[data-rz-h]');
    var elM = el.querySelector('[data-rz-m]');
    var elS = el.querySelector('[data-rz-s]');
    var CLAVE = 'rz_contador_fin_' + Math.round(horas);

    function calcularObjetivo() {
      if (modo === 'fecha') {
        var f = el.getAttribute('data-fecha-fin');
        var t = f ? new Date(f).getTime() : NaN;
        return isNaN(t) ? Date.now() + horas * 3600000 : t;
      }
      // rolling: guardar el fin por visitante
      var guardado;
      try { guardado = parseInt(localStorage.getItem(CLAVE), 10); } catch (e) { guardado = NaN; }
      if (!guardado || isNaN(guardado) || guardado < Date.now()) {
        guardado = Date.now() + horas * 3600000;
        try { localStorage.setItem(CLAVE, String(guardado)); } catch (e) {}
      }
      return guardado;
    }

    var objetivo = calcularObjetivo();
    var dos = function (n) { return n < 10 ? '0' + n : '' + n; };

    function pintar() {
      var restante = objetivo - Date.now();
      if (restante <= 0) {
        if (alTerminar === 'ocultar') { el.style.display = 'none'; clearInterval(t); return; }
        if (alTerminar === 'mensaje') {
          if (reloj) reloj.hidden = true;
          if (finMsg) finMsg.hidden = false;
          clearInterval(t);
          return;
        }
        // reiniciar
        if (modo === 'rolling') { try { localStorage.removeItem(CLAVE); } catch (e) {} }
        objetivo = calcularObjetivo();
        if (modo === 'fecha') { objetivo = Date.now() + horas * 3600000; }
        restante = objetivo - Date.now();
      }
      var s = Math.floor(restante / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (grupoDias) grupoDias.hidden = d <= 0;
      if (elD) elD.textContent = dos(d);
      if (elH) elH.textContent = dos(h);
      if (elM) elM.textContent = dos(m);
      if (elS) elS.textContent = dos(s);
    }

    pintar();
    var t = setInterval(pintar, 1000);
  });
}

/* ---------- Utilidad: formato de dinero ---------- */
function rzFormatoDinero(centavos) {
  var moneda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  try {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: moneda,
    });
  } catch (e) {
    return (centavos / 100).toFixed(2) + ' ' + moneda;
  }
}

/* ---------- Animaciones de entrada al hacer scroll ---------- */
function initReveal() {
  var els = document.querySelectorAll('.rz-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('rz-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rz-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

/* ---------- Marquesina infinita de reseñas ---------- */
function initResenasMarquesina() {
  var pista = document.querySelector('[data-rz-resenas-pista]');
  if (!pista) return;
  var fila = pista.querySelector('.rz-resenas__fila');
  if (!fila || fila.dataset.rzClonado) return;
  fila.dataset.rzClonado = '1';
  var clon = fila.cloneNode(true);
  clon.setAttribute('aria-hidden', 'true');
  pista.appendChild(clon);
}

/* ---------- Galería de producto: miniatura -> imagen principal ---------- */
function initGaleriaProducto() {
  document.querySelectorAll('[data-rz-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-rz-imagen-principal] img');
    var minis = galeria.querySelectorAll('[data-rz-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.setAttribute('src', src);
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

/* ---------- Producto: variantes de color + packs (bundle & save) ---------- */
function initProducto() {
  document.querySelectorAll('[data-rz-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-rz-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var seccion = form.closest('section') || document;
    var swatchGroups = form.querySelectorAll('[data-rz-opcion-grupo]');
    var idInput = form.querySelector('[data-rz-variant-id]');
    var cantidadOculta = form.querySelector('[data-rz-cantidad-oculta]');
    var packs = Array.prototype.slice.call(form.querySelectorAll('[data-rz-pack]'));

    var precioWrap = seccion.querySelector('.rz-producto__precio');
    var antesManualStr = precioWrap ? (precioWrap.getAttribute('data-rz-precio-antes-manual') || '').trim() : '';
    var antesManualNum = antesManualStr ? parseFloat(antesManualStr.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) : 0;
    var antesManualCent = antesManualNum > 0 ? Math.round(antesManualNum * 100) : 0;

    var precioActual = seccion.querySelector('[data-rz-precio-actual]');
    var precioAnterior = seccion.querySelector('[data-rz-precio-anterior]');
    var badgeOferta = seccion.querySelector('[data-rz-badge]');
    var badgeFoto = seccion.querySelector('[data-rz-badge-foto]');
    var botonComprar = form.querySelector('[data-rz-boton-comprar]');
    var stockAviso = form.querySelector('[data-rz-stock-aviso]');
    var barraPrecioActual = seccion.querySelector('[data-rz-barra-precio-actual]');
    var barraPrecioAnterior = seccion.querySelector('[data-rz-barra-precio-anterior]');
    var barraBoton = seccion.querySelector('[data-rz-barra-comprar]');

    function seleccionActual() {
      var sel = [];
      swatchGroups.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-activo');
        sel.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return sel;
    }
    function varianteActual() {
      var sel = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === sel[i]; });
      }) || variantes[0];
    }
    function packActivo() {
      var el = packs.find(function (p) { return p.classList.contains('is-activo'); });
      if (!el && packs.length) el = packs[0];
      return el;
    }

    function pintarPrecio(el, valor) { if (el) el.textContent = rzFormatoDinero(valor); }

    function actualizar() {
      var variante = varianteActual();
      if (!variante) return;

      if (idInput) idInput.value = variante.id;

      // color elegido (texto en negrita)
      swatchGroups.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-activo');
        var etiqueta = grupo.querySelector('[data-rz-opcion-elegida]');
        if (etiqueta && activo) etiqueta.textContent = activo.getAttribute('data-valor');
      });

      var base = parseInt(variante.price, 10);
      var comparaBase = variante.compare_at_price ? parseInt(variante.compare_at_price, 10) : 0;

      // precio "regular" por unidad para los tachados: manual del editor > comparado del catálogo > precio actual
      var regularUnidad = antesManualCent > base ? antesManualCent : (comparaBase > base ? comparaBase : base);

      // recalcular el precio de cada pack + guardar el pack activo
      var uds = 1, desc = 0;
      packs.forEach(function (p) {
        var u = parseInt(p.getAttribute('data-uds'), 10) || 1;
        var d = parseInt(p.getAttribute('data-descuento'), 10) || 0;
        var total = Math.round(base * u * (1 - d / 100));
        var antes = regularUnidad * u;
        var elTotal = p.querySelector('[data-rz-pack-total]');
        var elAntes = p.querySelector('[data-rz-pack-antes]');
        if (elTotal) elTotal.textContent = rzFormatoDinero(total);
        if (elAntes) {
          if (antes > total) { elAntes.textContent = rzFormatoDinero(antes); elAntes.hidden = false; }
          else { elAntes.hidden = true; }
        }
        if (p.classList.contains('is-activo')) { uds = u; desc = d; }
      });

      // cantidad que se añadirá al carrito
      if (cantidadOculta) cantidadOculta.value = uds;

      // ---- Precio de arriba: SIEMPRE el de 1 unidad (como en las tiendas de referencia) ----
      pintarPrecio(precioActual, base);
      // "antes" prioritario: valor manual del editor; si no, el precio comparado del catálogo
      var antesCent = antesManualCent > base ? antesManualCent : (comparaBase > base ? comparaBase : 0);
      if (precioAnterior) {
        if (antesCent > base) {
          if (antesManualCent > base) { precioAnterior.textContent = antesManualStr; }
          else { precioAnterior.textContent = rzFormatoDinero(antesCent); }
          precioAnterior.hidden = false;
        } else {
          precioAnterior.hidden = true;
        }
      }
      var pctBadge = antesCent > base ? Math.round((antesCent - base) / antesCent * 100) : 0;
      [badgeOferta, badgeFoto].forEach(function (b) {
        if (!b) return;
        if (pctBadge > 0) { b.textContent = '-' + pctBadge + '%'; b.hidden = false; }
        else { b.hidden = true; }
      });

      // ---- Barra móvil: el TOTAL del pack elegido (lo que pagará al comprar) ----
      var totalSel = Math.round(base * uds * (1 - desc / 100));
      var antesSel = regularUnidad * uds;
      if (barraPrecioActual) {
        barraPrecioActual.textContent = rzFormatoDinero(totalSel) + (uds > 1 ? ' · ' + uds + ' uds' : '');
      }
      if (barraPrecioAnterior) {
        if (antesSel > totalSel) { barraPrecioAnterior.textContent = rzFormatoDinero(antesSel); barraPrecioAnterior.hidden = false; }
        else { barraPrecioAnterior.hidden = true; }
      }

      // disponibilidad
      [botonComprar, barraBoton].forEach(function (b) {
        if (!b) return;
        b.disabled = !variante.available;
        b.textContent = variante.available
          ? b.getAttribute('data-texto-disponible')
          : b.getAttribute('data-texto-agotado');
      });
      if (stockAviso) stockAviso.hidden = variante.available;

      // swatches no disponibles
      swatchGroups.forEach(function (grupo, i) {
        grupo.querySelectorAll('[data-rz-opcion-valor]').forEach(function (btn) {
          var prueba = seleccionActual();
          prueba[i] = btn.getAttribute('data-valor');
          btn.disabled = !variantes.some(function (v) {
            return v.options.every(function (val, j) { return val === prueba[j]; }) && v.available;
          });
        });
      });
    }

    // eventos: swatches de color
    swatchGroups.forEach(function (grupo) {
      grupo.querySelectorAll('[data-rz-opcion-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-rz-opcion-valor]').forEach(function (b) { b.classList.remove('is-activo'); });
          btn.classList.add('is-activo');
          actualizar();
        });
      });
    });

    // eventos: packs
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (o) { o.classList.remove('is-activo'); });
        p.classList.add('is-activo');
        var radio = p.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        actualizar();
      });
    });

    // barra móvil: reusar el botón real
    if (barraBoton && botonComprar) {
      barraBoton.addEventListener('click', function () { botonComprar.click(); });
    }

    actualizar();
  });
}

/* ---------- Comparador antes / después ---------- */
function initComparadorAntesDespues() {
  document.querySelectorAll('[data-rz-comparador]').forEach(function (comparador) {
    var marco = comparador.querySelector('[data-rz-comparador-marco]');
    var rango = comparador.querySelector('[data-rz-comparador-rango]');
    var antes = comparador.querySelector('[data-rz-comparador-antes]');
    var asa = comparador.querySelector('[data-rz-comparador-asa]');
    if (!marco || !rango || !antes || !asa) return;

    var arrastrando = false;

    function fijar(valor) {
      var v = Math.max(0, Math.min(100, valor));
      rango.value = v;
      antes.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      asa.style.left = v + '%';
    }
    function valorDesdePuntero(evt) {
      var rect = marco.getBoundingClientRect();
      return ((evt.clientX - rect.left) / rect.width) * 100;
    }

    marco.addEventListener('pointerdown', function (evt) {
      arrastrando = true;
      if (marco.setPointerCapture) marco.setPointerCapture(evt.pointerId);
      fijar(valorDesdePuntero(evt));
      evt.preventDefault();
    });
    marco.addEventListener('pointermove', function (evt) {
      if (!arrastrando) return;
      fijar(valorDesdePuntero(evt));
    });
    ['pointerup', 'pointercancel'].forEach(function (nombre) {
      marco.addEventListener(nombre, function () { arrastrando = false; });
    });
    rango.addEventListener('input', function () { fijar(parseFloat(rango.value)); });

    fijar(parseFloat(rango.value) || 50);
  });
}

/* ---------- Selector de cantidad (solo si no hay packs) ---------- */
function initCantidadProducto() {
  document.querySelectorAll('[data-rz-cantidad]').forEach(function (caja) {
    var input = caja.querySelector('input');
    var menos = caja.querySelector('[data-rz-menos]');
    var mas = caja.querySelector('[data-rz-mas]');
    if (!input) return;
    menos && menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    mas && mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
